import { zodResolver } from '@hookform/resolvers/zod';
import { useMutation } from '@tanstack/react-query';
import { createFileRoute, Link } from '@tanstack/react-router';
import { useForm } from 'react-hook-form';
import { z } from 'zod';

import { AuthCard } from '@/components/auth/auth-card';
import { AuthField } from '@/components/auth/auth-field';
import { AuthForm } from '@/components/auth/auth-form';
import { signUpFn } from '@/server/functions/auth';

export const Route = createFileRoute('/_auth/sign-up')({
    component: SignUpPage,
});

const signUpSchema = z.object({
    name: z.string().trim().min(1, 'נא להזין שם מלא').max(128),
    email: z.email('נא להזין כתובת אימייל תקינה'),
    password: z.string().min(8, 'הסיסמה חייבת להכיל לפחות 8 תווים'),
});

function SignUpPage() {
    const form = useForm({
        resolver: zodResolver(signUpSchema),
        defaultValues: {
            name: '',
            email: '',
            password: '',
        },
    });

    const signUpMutation = useMutation({
        mutationFn: async (data: z.infer<typeof signUpSchema>) => {
            await signUpFn({
                data: {
                    name: data.name,
                    email: data.email,
                    password: data.password,
                    redirect: '/admin',
                },
            });
        },
        onError: (error: Error) => {
            form.setError('root', { message: error.message });
        },
    });

    return (
        <AuthCard
            title="הרשמה"
            description="פתחו חשבון כדי לגשת למערכת הניהול."
            footer={
                <Link to="/sign-in" className="!no-underline hover:underline">
                    יש לכם חשבון? התחברות
                </Link>
            }
        >
            <AuthForm
                schema={signUpSchema}
                defaultValues={{ name: '', email: '', password: '' }}
                onSubmit={(data) => signUpMutation.mutate(data)}
                submitText="יצירת חשבון"
                isLoading={signUpMutation.isPending}
                form={form}
            >
                {(f) => (
                    <>
                        <AuthField
                            control={f.control}
                            name="name"
                            label="שם מלא"
                            placeholder="ישראל ישראלי"
                        />
                        <AuthField
                            control={f.control}
                            name="email"
                            label="אימייל"
                            placeholder="editor@ashkelon.news"
                            type="email"
                        />
                        <AuthField
                            control={f.control}
                            name="password"
                            label="סיסמה"
                            placeholder="לפחות 8 תווים"
                            type="password"
                        />
                    </>
                )}
            </AuthForm>
        </AuthCard>
    );
}
